export interface Testimonial {
  name: string
  role: string
  location: string
  age: number
  quote: string
}

export const testimonials: Testimonial[] = [
  {
    name: 'Mike Donnelly',
    role: 'Master Automotive Technician, independent shop',
    location: 'Columbus, Ohio, United States',
    age: 44,
    quote:
      'Twenty years in the bays and my problem was never knowing engines, it was the time lost between the scan tool, the service info and whatever video I could find. Last month I had a lean code with a rough idle that two other shops had thrown an O2 sensor at. I opened the vacuum leak map, checked fuel trims at idle versus 2,500 rpm like the reference shows, and found a split PCV hose in fifteen minutes. That one job paid for the system many times over.',
  },
  {
    name: 'Gareth Hughes',
    role: 'Vehicle Technician, franchise dealership',
    location: 'Cardiff, United Kingdom',
    age: 38,
    quote:
      'The misfire module changed how I approach random misfires. Instead of swapping coils around, I now compare misfire counters, fuel trims and injector data first. The structured path keeps me honest, and my warranty claims are cleaner because I can show exactly what I tested and why.',
  },
  {
    name: 'Jason Tremblay',
    role: 'Automotive Service Technician',
    location: 'Ottawa, Ontario, Canada',
    age: 29,
    quote:
      'I passed my licence but drivability jobs still scared me. The OBD-II and live data toolkit taught me to read the relationships between MAF, MAP and fuel trims instead of chasing each code. My foreman noticed I stopped asking him what to check next.',
  },
  {
    name: 'Brad Mitchell',
    role: 'Owner, automotive repair workshop',
    location: 'Adelaide, Australia',
    age: 52,
    quote:
      'I run five technicians and diagnostic time was where we lost money. Now every no-start and misfire follows the same worksheets, so handovers make sense and nothing gets tested twice. My comeback rate on drivability work has dropped noticeably. It reads like a reference built by someone who has actually stood at the fender.',
  },
  {
    name: 'Rachel Owens',
    role: 'Apprentice Technician, independent garage',
    location: 'Leicester, United Kingdom',
    age: 24,
    quote:
      'As an apprentice I needed something that explains why, not just what. The ECT and oxygen sensor pages made closed-loop control finally click for me, and I keep the quick reference handbook open on my tablet on every job. It has made me far more confident in front of my supervisor.',
  },
]
